<template>
  <div id="sidenav-collapse-main" class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse collapse-ref="menuTop" nav-text="User"
          :class="getRoute() === 'menuTop' ? 'active' : ''">
          <template #icon>
            <img :src="isLoading ? loadingImageUrl : profileImageSrc" class="avatar" />
          </template>
          <template #list>
            <ul class="nav pe-0">
              <li class="nav-item" :class="getRoute() === 'profile' ? 'active' : ''">
                <router-link class="nav-link" to="/profile" :class="getRoute() === 'profile' ? 'active' : ''">
                  <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">manage_accounts</i></span>
                  <span class="sidenav-normal me-3 ms-3 ps-1 text-white text-white">{{ $t('sidemenu.Profile') }}</span>
                </router-link>
              </li>
              <!--li class="nav-item" :class="getRoute() === 'resetpassword' ? 'active' : ''">
                <router-link class="nav-link" to="/resetpassword" :class="getRoute() === 'resetpassword' ? 'active' : ''">
                  <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">passkey</i></span>
                  <span class="sidenav-normal me-3 ms-3 ps-1 text-white text-white">{{ $t('sidemenu.Reset_password') }}</span>
                </router-link>
              </li-->
              <li class="nav-item">
                <a href="Javascript:void(0);" @click="fnLogout"
                  class="router-link-active router-link-exact-active nav-link" aria-current="page">
                  <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">logout</i></span>
                  <span class="sidenav-normal me-3 ms-3 ps-1 text-white text-white">{{ $t('sidemenu.Logout') }}</span>
                </a>
              </li>
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <hr class="horizontal light mt-2 mb-2" style="border-top: 1px solid #ccc;" />
      <li class="mt-3 nav-item" v-if="showKeeperUBN">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder text-white" style="color: #0f8d09 !important;" :class="isRTL ? 'me-4' : 'ms-2'">
          {{ $t('sidemenu.Active_UBN') }}: {{ this.$store.state.keeperUBN }}
        </h6>
      </li>
      <li class="mt-3 nav-item" v-if="showAssociationName">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder text-white" style="color: #0f8d09 !important;" :class="isRTL ? 'me-4' : 'ms-2'">
          {{ this.$store.state.associationAdminAssociationName }}
        </h6>
      </li>
      <li class="nav-item" :class="getRoute() === '' ? 'active' : ''" v-if="['Admin', 'AssociationAdmin', 'Keeper', 'Inspector'].includes(userRoleName)">
        <router-link class="nav-link" to="/" :class="getRoute() === '' ? 'active' : ''">
          <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">dashboard</i></span>
          <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Dashboard') }}</span>
        </router-link>
      </li>
      <li class="nav-item" :class="getRoute() === '' ? 'active' : ''" v-if="['Admin', 'AssociationAdmin', 'Keeper', 'Inspector'].includes(userRoleName)">
        <router-link class="nav-link" to="/search" :class="getRoute() === 'search' ? 'active' : ''">
          <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">search</i></span>
          <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Search') }}</span>
        </router-link>
      </li>
      <li class="nav-item" :class="getRoute() === 'logbook' ? 'active' : ''" v-if="['AssociationAdmin', 'Keeper'].includes(userRoleName)">
        <router-link class="nav-link" to="/logbook" :class="getRoute() === 'logbook' ? 'active' : ''">
          <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">auto_stories</i> </span>
          <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Logbook') }}</span>
        </router-link>
      </li>
      <li class="nav-item" :class="getRoute() === 'animal' ? 'active' : ''" v-if="['Inspector'].includes(userRoleName)">
        <router-link class="nav-link" to="/animal" :class="getRoute() === 'animal' ? 'active' : ''">
          <!--span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">pets</i> </span-->
          <img src="@/assets/img/animal.svg" class="opacity-10" style="width:20px; height:20px; margin-left: 4px;" />
          <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Animals') }}</span>
        </router-link>
      </li>
      <template v-if="showFullMenu">
        <li class="mt-3 nav-item">
          <h6 class="text-xs ps-4 text-uppercase font-weight-bolder text-white" :class="isRTL ? 'me-4' : 'ms-2'">
            {{ $t('sidemenu.My_stable') }}
          </h6>
        </li>
        <li class="nav-item" :class="getRoute() === 'animal' ? 'active' : ''" v-if="['Admin', 'AssociationAdmin', 'Keeper'].includes(userRoleName)">
          <router-link class="nav-link" to="/animal" :class="getRoute() === 'animal' ? 'active' : ''">
            <!--span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">pets</i> </span-->
            <img src="@/assets/img/animal.svg" class="opacity-10" style="width:20px; height:20px; margin-left: 4px;" />
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.My_animals') }}</span>
          </router-link>
        </li>
        <li class="nav-item" :class="getRoute() === 'eartag' ? 'active' : ''" v-if="['Admin', 'AssociationAdmin', 'Keeper'].includes(userRoleName)">
          <router-link class="nav-link" to="/eartag" :class="getRoute() === 'eartag' ? 'active' : ''">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">style</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Ear_tags') }}</span>
          </router-link>
        </li>             
        <li class="nav-item" :class="getRoute() === 'testmating' ? 'active' : ''" v-if="['Admin', 'AssociationAdmin', 'Keeper'].includes(userRoleName)">
          <router-link class="nav-link" to="/testmating" :class="getRoute() === 'testmating' ? 'active' : ''">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">hematology</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Testmatings') }}</span>
          </router-link>
        </li>
        <li class="nav-item" :class="getRoute() === 'mating' ? 'active' : ''" v-if="['Admin', 'AssociationAdmin', 'Keeper'].includes(userRoleName)">
          <router-link class="nav-link" to="/mating" :class="getRoute() === 'mating' ? 'active' : ''">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">gynecology</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Matings') }}</span>
          </router-link>
        </li>
        <li class="nav-item" :class="getRoute() === 'birth' ? 'active' : ''" v-if="['Admin', 'AssociationAdmin', 'Keeper'].includes(userRoleName)">
          <router-link class="nav-link" to="/birth" :class="getRoute() === 'birth' ? 'active' : ''">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">add_circle</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Birth') }}</span>
          </router-link>
        </li>
        
        <li class="nav-item" :class="{ active: getRoute() === 'keeper' && isOnLocationRoute() }" v-if="['Admin', 'AssociationAdmin', 'Keeper'].includes(userRoleName)">
          <router-link class="nav-link" to="/location" :class="{ active: getRoute() === 'keeper' && isOnLocationRoute() }">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">location_on</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Locations') }}</span>
          </router-link>
        </li>
        <li class="mt-3 nav-item">
          <h6 class="text-xs ps-4 text-uppercase font-weight-bolder text-white" :class="isRTL ? 'me-4' : 'ms-2'">
            {{ $t('sidemenu.Mutations') }}
          </h6>
        </li>
        <li class="nav-item" :class="getRoute() === 'departure' ? 'active' : ''" v-if="['Admin', 'AssociationAdmin', 'Keeper'].includes(userRoleName)">
          <router-link class="nav-link" to="/departure" :class="getRoute() === 'departure' ? 'active' : ''">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">output</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Departure') }}</span>
          </router-link>
        </li>
        <li class="nav-item" :class="getRoute() === 'death' ? 'active' : ''" v-if="['Admin', 'AssociationAdmin', 'Keeper'].includes(userRoleName)">
          <router-link class="nav-link" to="/death" :class="getRoute() === 'death' ? 'active' : ''">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">church</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Death') }}</span>
          </router-link>
        </li>
        <!--li class="nav-item" :class="getRoute() === 'missing' ? 'active' : ''">
          <router-link class="nav-link" to="/missing" :class="getRoute() === 'missing' ? 'active' : ''">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">broken_image</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Missing') }}</span>
          </router-link>
        </li-->
        <li class="nav-item" :class="getRoute() === 'retagging' ? 'active' : ''" v-if="['Keeper'].includes(userRoleName)">
          <router-link class="nav-link" to="/retagging" :class="getRoute() === 'retagging' ? 'active' : ''">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">style</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Retagging') }}</span>
          </router-link>
        </li>
        <li class="nav-item" :class="getRoute() === 'aretagging' ? 'active' : ''" v-if="['Admin', 'AssociationAdmin'].includes(userRoleName)">
          <router-link class="nav-link" to="/aretagging" :class="getRoute() === 'aretagging' ? 'active' : ''">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">style</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Retagging') }}</span>
          </router-link>
        </li>
        <!--
        <li class="nav-item" :class="{ active: $route.path === '/migration/import' }">
          <router-link class="nav-link" to="/migration/import" :class="{ active: $route.path === '/migration/import' }">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">input</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Import') }}</span>
          </router-link>
        </li>        
        -->
        <hr class="horizontal light mt-2 mb-2" style="border-top: 1px solid #ccc;" v-if="['Admin', 'AssociationAdmin'].includes(userRoleName)" />
        
        <li class="nav-item" :class="getRoute() === 'user' ? 'active' : ''" v-if="['Admin', 'AssociationAdmin'].includes(userRoleName)">
          <router-link class="nav-link" to="/user" :class="getRoute() === 'user' ? 'active' : ''">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">groups</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Users') }}</span>
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: getRoute() === 'association' && !isOnLocationRoute() }" v-if="['Admin'].includes(userRoleName)">
          <router-link class="nav-link" to="/association" :class="{ active: getRoute() === 'association' && !isOnLocationRoute() }">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">patient_list</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Associations') }}</span>
          </router-link>
        </li>        
        <li class="nav-item" :class="{ active: getRoute() === 'settings' }" v-if="['Admin', 'AssociationAdmin'].includes(userRoleName)">
          <router-link class="nav-link" to="/settings" :class="{ active: getRoute() === 'settings' }">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">settings</i> </span>
            <span class="sidenav-normal ms-2 text-white text-white">{{ $t('sidemenu.Settings') }}</span>
          </router-link>
        </li> 
        
        <hr class="horizontal light mt-2 mb-2" style="border-top: 1px solid #ccc;" v-if="['Admin', 'AssociationAdmin', 'Keeper', 'Inspector'].includes(userRoleName)" />

        <li class="nav-item" :class="{ active: getRoute() === 'settings' }" v-if="['Admin', 'AssociationAdmin', 'Keeper', 'Inspector'].includes(userRoleName)">
          <a href="Javascript:void(0);" @click="fnLogout"
            class="router-link-active router-link-exact-active nav-link" aria-current="page">
            <span class="sidenav-mini-icon text-white"><i class="material-symbols-rounded opacity-10">logout</i></span>
            <span class="sidenav-normal me-3 ms-3 ps-1 text-white text-white">{{ $t('sidemenu.Logout') }}</span>
          </a>          
        </li>         
      </template>
      <a
        class="m-0 navbar-brand"
        :href="normalizedAssociationUrl"
        target="_blank"
        rel="noopener noreferrer"
        v-if="['AssociationAdmin', 'Keeper'].includes(userRoleName)"
      >
        <img
          :src="isLoadingLogo ? loadingImageUrl : associationLogoImageSrc"
          class="navbar-brand-logo-img h-100"
          style="max-height: fit-content;"
        />
      </a>      
  </ul>
</div>
</template>
<script>

import axios from 'axios'
//import SidenavItem from "./SidenavItem.vue";
import SidenavCollapse from "./SidenavCollapse.vue";
//import SidenavCollapseItem from "./SidenavCollapseItem.vue";
import { mapGetters, mapState } from "vuex";
import loadingImageUrl from "@/assets/img/LoadingImage.gif";
import logo from "@/assets/img/Veeboek-logo.png";
import logoDark from "@/assets/img/Veeboek-logo.png";
import emitter from '@/eventBus';

export default {
  name: "SidenavList",
  components: {
    //SidenavItem,
    SidenavCollapse,
    //SidenavCollapseItem
  },
  data() {
    return {
      noOfRecords: 0,      
      isActive: "active",
      profileImageSrc: null,
      isLoading: true,
      loadingImageUrl,
      associationLogoImageSrc: null,
      isLoadingLogo: true,      
      logo,
      logoDark
    };
  },
  computed: {
    ...mapGetters(['user']),
    ...mapState(["isRTL"]),
    userRoleName() {
        return this.$store.state.user?.roleName;
    },
    showFullMenu() {
      const role = this.$store.state.roleName;
      const keeperLocationId = this.$store.state.keeperLocationId;
      return role === 'Admin' || role === 'AssociationAdmin' || (role === 'Keeper' && keeperLocationId);
    },
    showKeeperUBN() {
      const role = this.$store.state.roleName;
      const keeperLocationId = this.$store.state.keeperLocationId;
      return (role === 'Keeper' && keeperLocationId);
    },
    showAssociationName() {
      const role = this.$store.state.roleName;      
      return (role === 'AssociationAdmin');
    },
    normalizedAssociationUrl() {
      const url = this.$store.state.associationWebsiteURL;
      if (!url) return null;
      return url.startsWith("http://") || url.startsWith("https://")
        ? url
        : `https://${url}`;
    }
  },
  async mounted() {   
    emitter.on('profile:image-updated', this.fetchUserImage);
    await this.fetchUserImage();
    
    await this.fetchAssociationLogoImage()
  },
  beforeUnmount() {
    emitter.off('profile:image-updated', this.fetchUserImage);
  },
  methods: {
    async fetchUserImage() {
        try {
          this.isLoading = true;
          const response = await axios.get('user/getprofileimage/', {
            params: { aspNetUserId: this.user.id, t: Date.now() }, // cache-bust
            responseType: 'blob'
          });
          // revoke old blob URL to avoid leaks
          if (this.profileImageSrc?.startsWith('blob:')) {
            URL.revokeObjectURL(this.profileImageSrc);
          }
          this.profileImageSrc = URL.createObjectURL(response.data);
        } finally {
          this.isLoading = false;
        }
    },    
    async fetchAssociationLogoImage() {
        try {
          this.isLoadingLogo = true;

          let associationId = null;
          const role = this.$store.state.roleName;

          if (role === "Keeper") {
            associationId = this.$store.state.keeperAssociationId;
          } else if (role === "AssociationAdmin") {
            associationId = this.$store.state.associationAdminAssociationId;
          }

          if (!associationId) {
            console.warn("No associationId found for this role:", role);
            return;
          }

          const response = await axios.get(`association/getassociationlogo/`, {
            params: { associationId },
            responseType: 'blob'
          });

          const imageBlob = response.data;
          this.associationLogoImageSrc = URL.createObjectURL(imageBlob);
        } catch (error) {
          console.error('Error fetching association image:', error);          
        } finally {
            this.isLoadingLogo = false; // Set loading state to false after fetching
        }
    },
    fnLogout() {
      // Remove token and user from session storage
      sessionStorage.removeItem('sheepbase-token');
      sessionStorage.removeItem('user');
      
      sessionStorage.removeItem('eartagsPageRefreshed');

      // Remove login date from local storage
      localStorage.removeItem('login-date');

      // Clear user from Vuex store
      this.$store.dispatch('user', null);

      // Reload the page or redirect to login
      window.location.reload(true);
      // Alternatively: 
      //this.$router.push('/login'); 
    },
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    isOnLocationRoute() {
      return (this.$route.path.includes('/keeper/location') || this.$route.path.includes('/keeper/createlocation'));
    },    
    isKeeperIdUndefined() {
      // Check if the keeperId parameter is undefined
      return !this.$route.params.id; // or this.$route.params.id === undefined
    }
  }
};
</script>
<style>
.text-bg-success {
  color: #fff !important;
  background-color: RGBA(25, 135, 84, var(--bs-bg-opacity, 1)) !important;
}
</style>